import DOMPurify from 'dompurify'
import { marked } from 'marked'

import { cn } from '@repo/utils'

import styles from './index.css'

import type { FC } from 'react'

export interface MarkdownProps {
  children: string
  className?: string
  gfm?: boolean
  silent?: boolean
}

const Markdown: FC<MarkdownProps> = ({ children, className = '', gfm = true, silent = true }) => {
  marked.use({
    gfm,
    silent,
  })
  const rawMarkup = DOMPurify.sanitize(marked.parse(children.trim(), { async: false }))

  return <div className={cn(styles.container, className)} dangerouslySetInnerHTML={{ __html: rawMarkup }} />
}

export default Markdown
